import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosResponse } from "axios";
import { axiosClient } from "../axiosClient";
import { TagResponse } from "../../models/Tags";

export const fetchTagResponses = createAsyncThunk('tagResponse/getTagsResponses', async (params: {agencyId: number, clientId: number}) => {
    const response: AxiosResponse<TagResponse[]> = await (await axiosClient()).get(`/agencies/${params.agencyId}/clients/${params.clientId}/tags/responses`);
    return response.data
});
